import Users from "layouts/users";
import Icon from "@mui/material/Icon";
import Dashboard from "layouts/dashboard";
import Scenarios from "layouts/scenarios";
import Analytics from "layouts/analytics";
import SignIn from "layouts/authentication/sign-in";
import ScenarioDetail from "layouts/scenarios/scenario-detail";
import Profile from "layouts/profile";
import ForgotPassword from "layouts/authentication/forgot-password/cover";
import ResetPassword from "layouts/authentication/reset-password";
import VerifyEmail from "layouts/authentication/verify-email";
import AnalyticsReport from "layouts/analytics-report";
import AnalysisData from "layouts/analytics/analysis-data";
import ProtectedRoute from "components/ProtectedRoute";
import RoleProtectedRoute from "components/RoleProtectedRoute";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    component: <ProtectedRoute><Dashboard /></ProtectedRoute>,
    icon: <Icon fontSize="small">dashboard</Icon>,
    roles: ["admin", "user"],
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">group</Icon>,
    route: "/users",
    component: <RoleProtectedRoute allowedRoles={["admin"]}><Users /></RoleProtectedRoute>,
    roles: ["admin"],
  },
  {
    type: "collapse",
    name: "Analytics",
    key: "analytics",
    icon: <Icon fontSize="small">analytics</Icon>,
    route: "/analytics",
    component: <ProtectedRoute><Analytics /></ProtectedRoute>,
    roles: ["user", "admin"],
  },
  {
    name: "analysis",
    key: "analysis",
    route: "/analysis-data/:violationType",
    component: <ProtectedRoute><AnalysisData /></ProtectedRoute>,
    roles: ["user", "admin"],
  },
  {
    name: "scenarios",
    key: "scenarios",
    route: "/scenarios/:id",
    component: <ProtectedRoute><Scenarios /></ProtectedRoute>,
    roles: ["user", "admin"],
  },
  {
    name: "scenarios-detail",
    key: "scenarios-detail",
    route: "/scenarios-detail/:id",
    component: <ProtectedRoute><ScenarioDetail /></ProtectedRoute>,
    roles: ["user", "admin"],
  },
  {
    type: "collapse",
    name: "User Profile",
    key: "profile",
    route: "/profile",
    component: <ProtectedRoute><Profile /></ProtectedRoute>,
    icon: <Icon fontSize="small">person</Icon>,
    roles: ["user", "admin",],
  },
  {
    name: "login",
    key: "login",
    route: "/login",
    component: <SignIn />,
  },
  {
    name: "verify-email",
    key: "verify-email",
    route: "/verify-email",
    component: <VerifyEmail />,
  },
  {
    name: "forgot-password",
    key: "forgot-password",
    route: "/forgot-password",
    component: <ForgotPassword />,
  },
  {
    name: "reset-password",
    key: "reset-password",
    route: "/reset-password/:id/:token",
    component: <ResetPassword />,
  },
  {
    name: "analytics-report",
    key: "analytics-report",
    route: "/analytics/report/:token",
    component: <ProtectedRoute><AnalyticsReport /></ProtectedRoute>,
    roles: ["user", "admin"],
  },
].filter(Boolean);

export default routes;
